import { Platform, StyleSheet } from 'react-native';
import { isWeb } from './utils/Helper';




export const theme = {
  PRIMARY_FONT: {
    fontFamily: 'BradfordLL-Light',
    fontWeight: 300,
  },
  SECONDARY_FONT: {
    fontFamily: 'GoodSans-Medium',
    fontWeight: 300,
  },

  TERTIARY_FONT: {
    fontFamily: "GoodSans-Bold",
  },

  FONT_XSMALL: {
    fontSize: 8,
    lineHeight: 14,
    // letterSpacing: -0.2,
    fontWeight: 500
  },
  FONT_SMALL: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: -0.2,
  },
  FONT_MEDIUM: {
    fontSize: 14,
    lineHeight: 20,
  },
  FONT_LARGE: {
    fontSize: 24,
    lineHeight: 28,
    fontWeight: 300,
  },
  FONT_XLARGE: {
    fontSize: 30,
    lineHeight: 36,
    fontWeight: 400,
  },
  FONT_XXLARGE: {
    fontSize: 30,
    lineHeight: 36,
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#FFFFFF', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#343434',

    BACKGROUND_COLOR_SECONDARY: "#1D1D1D", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#FFFFFF",

    PRIMARY_COLOR: "#FFFFFF", // primary color
    PRIMARY_TEXT_COLOR: "#1D1D1D", // primary text color

    SECONDARY_COLOR: "#E14225", // secondary color
    SECONDARY_TEXT_COLOR: "#FFFFFF", // secondary text color

    ACCENT_COLOR: "#E14225",
    ACCENT_Text_COLOR: "#D9D9D9",

    TERTIARY_TEXT_COLOR: "#858585",
  },
};


export default StyleSheet.create({
  input: {
    borderRadius: 0,
    shadowOpacity: 0,
  },
  headerContainerLogo: {
    width: 162,
  },
  promoWidgetImageStyle: {
    height: 292,
  },
  tabIcon: {
    height: 28,
    width: 28,
    objectFit: "contain",
    resizeMode: "contain"
  },
  backText: {
    color: theme.COLORS.WHITE,
  },
  backIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },
  notificationIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },
  headerContainer: {
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY,
  },
  customSliderContainer: {
    borderRadius: null
  },
  customSliderThumb: {
    borderRadius: null,
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY
  },
  customSliderArrowIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },
  welcomeScreenLogoStyle:{
    width: 205,
    height: 143,
  },
  welcomeScreenOverlay: {
    display: "flex",
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY,
  },
  welcomeScreenContent: {
    gap: null,
    justifyContent: "flex-end",
    paddingHorizontal: 16
  },
  welcomeScreenBottomTxtCont: {
    marginBottom: null
  },
  welcomeScreenBottomTxt: {
    color: theme.COLORS.WHITE
  },
  welcomeScreenBottomLoginContainer: {
    marginBottom: 24,
  },
  primaryBtn: {
    borderRadius: null,
  },
  secondaryBtn: {
    borderRadius: null,
  },
  welcomeScreenTertiaryBtnTxt: {
    color: theme.COLORS.WHITE
  },
  primaryBtnTxt: {
    color: theme.COLORS.WHITE
  },
  widgetmainContainerHeaderTitleContainer: {
    backgroundColor: "#F8F8F8",
    paddingVertical: 30,
  },
  widgetmainContainerHeaderTitle: {
    ...theme.FONT_LARGE,
    textTransform: null,
  },
  widgetmainContainerHeaderSubTitle: {
    ...theme.PRIMARY_FONT,
  },
  label: {
    textTransform: "uppercase",
  },
  customSliderText: {
    color: theme.COLORS.WHITE
  },
  hcommerce_storelevel1_MainContainerChildContainerPillContainer: {
    backgroundColor: theme.COLORS.WHITE,
    marginTop: null,
    paddingTop: 30,
  },
  hcommerce_storelevel1_PillContainer:{
    gap: 10,
    paddingRight: 20,
    paddingTop: 16,
    paddingBottom: 16,
    marginLeft: 16,
  },
  hcommerce_storelevel1_Pill:{
    borderWidth: 1.5,
    borderColor: theme.COLORS.PRIMARY_TEXT_COLOR,
    borderBottomWidth: 1.5,
  },
  hcommerce_storelevel1_Pill_Text:{
    ...theme.SECONDARY_FONT,
    textTransform: "uppercase",
  },
  hcommerce_storelevel1_SelectedPill: {
    backgroundColor: theme.COLORS.ACCENT_COLOR,
  },
  hcommerce_storelevel1_SelectedPill_Text: {
    color: theme.COLORS.WHITE,
  },

  hcommerce_storelevel1_ChildContainer: {
    gap: 8,
  },
  hcommerce_storelevel1_ChildContainer_Title: {
    ...theme.FONT_LARGE,
  },
  hcommerce_storelevel1_itemContainer_textContainer_currencytitle: {
    ...theme.PRIMARY_FONT,
  },
  list_itemContainer: {
    borderBottomWidth: 1,
    borderBottomColor: "#4D4D4D"
  },
  widgetSkeleton_itemContainer: {
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  viewBill_Item_textContainer: {
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.10)"
  },
  list_itemContainer_textContainer: {
    height: 62,
  },

  list_itemContainer_textContainer_title: {
    ...theme.FONT_SMALL,
  },
  AddOnsModalContent_childcontainer_header_container: {
    paddingTop: 40,
  },
  welcomeScreenPrimaryBtn: {
    borderRadius: null,
    marginBottom: 12,
  },
  welcomeScreenTertiaryBtn: {
    borderRadius: null,
    marginBottom: 24,
  },
  welcomeScreenBottomLoginTxt: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_MEDIUM,
    color: theme.COLORS.WHITE
  },
  welcomeScreenBottomLoginBtnTxt: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_MEDIUM,
    color: theme.COLORS.WHITE
  },
  mainContainerHeaderContainer: {
    display: "none",
  },
  dropdown: {
    borderRadius: 0,
  },
  dropdown_web: {
    borderRadius: 0,
  },
  multipleLargeWidgetContainer: {
    paddingTop: 24,
    paddingBottom: 24,
  },
  multipleLargeWidgetTitleText: {
    ...theme.FONT_LARGE,
  },
  multipleLargeWidgetDescriptionText: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_MEDIUM,
    marginTop: 4,
  },
  multipleLargeWidgetViewAll: {
    display: "none",
  },
  multipleLargeWidgetDescriptionContainer: {
    display: "none"
  },
  multipleLargeWidget_WidgetsImg: {
    height: 260,
    width: 175,
    objectFit: "cover",
  },
  multipleLargeWidget_WidgetsTitleContainer: {
    position: "absolute",
    bottom: 0,
    padding: 16,
    gap: 10
  },
  multipleLargeWidget_WidgetsContainer: {
    width: 175,
  },
  multipleLargeWidget_WidgetsTitleText: {
    ...theme.TERTIARY_FONT,
    ...theme.FONT_MEDIUM,
    color: theme.COLORS.WHITE,
    width: 130,
    fontWeight: 700
  },
  multipleLargeWidget_WidgetsSubTitleText: {
    ...theme.PRIMARY_FONT,
    fontSize: 12,
    fontWeight: 400,
    color: theme.COLORS.WHITE,
  },
  multipleLargeWidget_WidgetsButtonContainer: {
    borderWidth: 0,
    paddingHorizontal: null,
    paddingVertical: 4,
    alignItems: null,
    height: 22,
    borderBottomWidth: 1,
    borderBottomColor: theme.COLORS.SECONDARY_COLOR,
    width: 92
  },
  multipleLargeWidget_WidgetsButtonContainerText: {
    ...theme.TERTIARY_FONT,
    color: theme.COLORS.SECONDARY_COLOR,
    fontWeight: 500,
    lineHeight: 14
  },
  multipleLargeWidget_MainWidgetsContainer: {
    gap: 16,
    marginTop: 16,
  },
  bannerWidgetTitle: {
    ...theme.FONT_SMALL,
  },
  bannerWidgetDescription: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_SMALL,
    textTransform: null
  },
  bannerWidgetImageStyle: {
    height: 64,
    width: 64
  },
  bannerWidgetTextContainer: {
    gap: 4
  },
  "infoWidgetHeaderSubtitle_info-heading-text": {
      "color": "#343434",
      "fontFamily": "BradfordLL-Regular"
  },
  "guestrequest_childcontainer_itemContainer_textContainer_subtitle": {
      "display": "none"
  },
  "guestrequestdetails_textContainer_subtitle": {
      "display": "none"
  },
  guestrequest_HeaderTitleContainer: {
    position: "absolute",
    backgroundColor: "transparent",
  },
  guestrequest_HeaderTitle: {
    fontSize: 40,
    lineHeight: null,
    color: theme.COLORS.SECONDARY_TEXT_COLOR,
  },
  notificationsHeaderTitleContainer: {
    position: "absolute",
    backgroundColor: "transparent",
  },
  notificationsHeaderTitle: {
    fontSize: 40,
    lineHeight: null,
    color: theme.COLORS.SECONDARY_TEXT_COLOR,
  },
  "infoWidgetsWidgetContainer_info-heading-only": {
    paddingTop: 32,
    paddingBottom: 0,
  },
  "infoWidgetHeaderTitle_info-heading-only": {
    ...theme.FONT_LARGE,
    textAlign: "left",
    textTransform: "none"
  },
  widgetmainContainerHeaderImg: {
    height: 292
  },
  "infoWidgetHeaderTitle_info-heading-text": {
    textTransform: "none",
    fontFamily: null
  },
  infoWidgetHeaderSubtitle: {
    paddingHorizontal: 3, 
  },
  "infoWidgetsWidgetContainer_info-banner-image": {
    paddingHorizontal: 0,
  },
  "infoWidgetImageStyle_info-banner-image": {
    height: 120,
  },
  loginModalContainer: {
    maxHeight: 600
  },
  guestDetailsDateItemContainer: {
    borderColor: theme.COLORS.ACCENT_Text_COLOR,
    justifyContent: "center",
    alignItems: "center",
  },
  guestDetailsDateItemTitle: {
    ...theme.FONT_SMALL,
    color: theme.COLORS.TERTIARY_TEXT_COLOR,
  },
  guestDetailsDateItemSubTitle: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_MEDIUM,
    color: theme.COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  guestDetailsHeaderTitle: {
    fontFamily: [theme.PRIMARY_FONT.fontFamily, theme.SECONDARY_FONT.fontFamily],
    textTransform: "none",
  },

  guestDetailsHeaderSubtitle: {
    ...theme.PRIMARY_FONT,
  },
  viewBillDateItemContainer: {
    borderColor: theme.COLORS.ACCENT_Text_COLOR,
    justifyContent: "center",
    alignItems: "center",
  },
  viewBillDateItemTitle: {
    ...theme.FONT_SMALL,
    color: theme.COLORS.TERTIARY_TEXT_COLOR,
  },
  viewBillDateItemSubTitle: {
    ...theme.PRIMARY_FONT,
    ...theme.FONT_MEDIUM,
    color: theme.COLORS.BACKGROUND_COLOR_CONTRAST,
  },
  viewBillHeaderTitle: {
    ...theme.PRIMARY_FONT,
    textTransform: "none",
  },
  bannerWidgetMainContainer: {
      backgroundColor: theme.COLORS.BACKGROUND_COLOR,
    },
});
